import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

import Header from '../components/header'
import Footer from '../components/Footer'
import './app.scss'

const LayoutOne = ({ children }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <>
      <Helmet
        title={data.site.siteMetadata.title}
        meta={[
          { name: 'description', content: 'Sample' },
          { name: 'keywords', content: 'sample, something' },
        ]}
      >
        <html lang="en" />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div className="container">
        <div className="pure-g">
          <div className="pure-u-1">
            <main className="content" role="main">
              {children}
            </main>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

LayoutOne.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutOne
